import { IonCard, IonCardHeader, IonCardTitle } from "@ionic/react";

import "./DataScienceProjects.css";
import CoffeeControlChart from "./DSProjects/CoffeeControlChart";
import MultiIris from "./DSProjects/MultiIris";
import DBSCANIris from "./DSProjects/DBSCANIris";

function DataScienceProjects() {
  return (
    <IonCard className="ion-padding">
      <IonCardHeader>
        <IonCardTitle></IonCardTitle>
      </IonCardHeader>

      <CoffeeControlChart />
      <MultiIris />
      <DBSCANIris />
    </IonCard>
  );
}

export default DataScienceProjects;
